export interface PermissionExtensionBlockerRow {
  id: string;
  extension: string;
  blocker: string;
  auditPrivacyConstraint: string;
}

export function getPermissionExtensionBlockerRows(): PermissionExtensionBlockerRow[] {
  return [
    {
      id: "permission-templates",
      extension: "Permission templates",
      blocker: "super-admin-permission-management-backend",
      auditPrivacyConstraint: "Template changes need a complete permission history record before any editing is enabled."
    },
    {
      id: "view-as-impersonation",
      extension: "View-as and impersonation",
      blocker: "audited-view-as-impersonation-backend",
      auditPrivacyConstraint: "Every view-as session needs explicit actor, target, reason, expiry, and redacted event history."
    },
    {
      id: "permission-history",
      extension: "Permission history",
      blocker: "permission-history-redaction-backend",
      auditPrivacyConstraint: "History must redact private payloads and expose support references without raw authorization data."
    },
    {
      id: "billing-plan-subscription-contract",
      extension: "Billing, plan, subscription, and contract surfaces",
      blocker: "billing-subscription-contract-backend",
      auditPrivacyConstraint: "Commercial account data stays hidden until ownership and access rules are finalized."
    },
    {
      id: "integration-credentials",
      extension: "Zoom and Microsoft 365 credential management",
      blocker: "integration-credential-vault-backend",
      auditPrivacyConstraint: "Provider credentials must stay absent from browser UI unless an audited credential-vault flow exists."
    }
  ];
}

export interface PermissionDeniedPostureRow {
  id: string;
  role: "admin" | "company_admin" | "coach" | "participant";
  posture: string;
}

export function getPermissionDeniedPostureRows(): PermissionDeniedPostureRow[] {
  return [
    { id: "admin-denial", role: "admin", posture: "generic not-found; no permission templates, grants, or blockers render" },
    { id: "company-admin-denial", role: "company_admin", posture: "generic not-found; assigned company data does not imply permission management" },
    { id: "coach-denial", role: "coach", posture: "generic not-found; coach scope cannot view permission management" },
    { id: "participant-denial", role: "participant", posture: "generic not-found; participant keeps own profile only" }
  ];
}
